import React, { useEffect } from 'react'
import '../styles/careers.css'
import Chevron from '../assets/icons/ChevronDown.png'
import Cube from '../assets/images/Cube.png'
import Dots from '../assets/images/Dots.png'
import Arrow from '../assets/images/Arrow1.png'
import Amalgam from '../assets/images/Amalgam-logo.png'
import Facebook from '../assets/images/Facebook.png'
import Instagram from '../assets/images/Instagram.png'
import X from '../assets/images/X.png'
import LinkedIn from '../assets/images/LinkedIn.png'
import Youtube from '../assets/images/Youtube.png'
import { Link, useNavigate } from 'react-router-dom'
import Accordion from '../assets/components/AccordionCareers'
import { useMediaQuery } from 'react-responsive';

function Careers() {

  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 570 });
  const isTablet = useMediaQuery({ maxWidth: 1100 });
  return (
    <div style={{ position: "relative", zIndex: 1 , backgroundColor: "white"}}>
      <section className='careers-row-1'>
        <h1>Amalgamate with us</h1>
        <p>Explore exciting career opportunities and become part of our success story.</p>
      </section>

      <section className='careers-row-2'>
        <div className='careers-row-2-header'>
          <h2>Our open roles</h2>
        </div>
        <Accordion />
        {/*
        
        <div style={{ width: "100%" }}>
          <div className='careers-row-2-divider' />
          <div className='careers-row-2-dropdown'>
            <h1>Sales Department</h1>
            <button><img src={Chevron} alt='Chevron'/></button>
          </div>
          <div className='careers-row-2-divider' />
          <div className='careers-row-2-dropdown'>
            <h1>Operation Department</h1>
            <button><img src={Chevron} alt='Chevron'/></button>
          </div>
        </div> */}
      </section>

      <section className='careers-row-3'>
        <h1>You'll love it here if:</h1>
        <div className='careers-row-3-content'>
          <div className='careers-row-3-right-content'>
            <h3>You want to be valued for your professionalism.</h3>
            <p>Everyone has a voice, and each opinion is valued. We encourage our team members to always take ownership of their work.</p>
          </div>
          <div className='careers-row-3-right-content'>
            <h3>You always put the client first.</h3>
            <p>We are genuinely committed to making our clients happy by providing exceptional support. We think creatively and are passionate about delivering high-quality work.</p>
          </div>
          <div className='careers-row-3-right-content'>
            <h3>You value your freedom.</h3>
            <p>We give our team members the direction they need and the space they deserve to thrive. We also work asynchronously from anywhere in the world.</p>
          </div>
          <div className='careers-row-3-right-content'>
            <h3>You're a lifelong student.</h3>
            <p>We're curious, love to experiment, and view mistakes as learning opportunities. We strive for continuous improvement so that each day we become wiser and more confident than the one before.</p>
          </div>
        </div>
      </section>

      <section className='ourwork-row-14 blog-row-14'>
                <h2>Get in touch</h2>
                <p>Reach out to us to gather more information or <br className='blog-row-14-break' />  set our wheels in motion.</p>
                <div className='ourwork-arrow-box blog-arrow-box'>
                    <img src={Arrow} alt="arrow" className='ourwork-arrow' />
                    <button onClick={() => navigate("/contactus")}>Let's talk</button>
                </div>

            </section>
      {!isTablet ? (
        <section className='home-footer'>
          <div className='home-footer-middle'>
            <img src={Amalgam} alt="Amalgam" className='home-footer-amalgam' />
            <Link to="/" className='home-footer-links'>Home</Link>
            <Link to="/ourwork" className='home-footer-links'>Our Work</Link>
            <Link to="/aboutus" className='home-footer-links'>About Us</Link>
            <Link to="/case-studies" className='home-footer-links'>Case Studies</Link>
            <Link to="/startups" className='home-footer-links'>Launchpad</Link>
            <Link to="/careers" className='home-footer-links'>Careers</Link>
            <Link to="/contactus" className='home-footer-links'>Contact Us</Link>
            <img src={LinkedIn} alt="Instagram" className='home-footer-linkedin' />
          </div>
          <div className='home-footer-dividor'>
            <div className='home-footer-policies'>
              <p><Link to="/privacy-policy">Privacy Policy</Link></p>
              <p><Link to="/terms-and-conditions">Terms and Conditions</Link></p>
              <p><Link to="/cookie-policy">Cookie Policy</Link></p>
            </div>
          </div>
        </section>
      ) : (
        <section>
          <div className="footer-minimal">
            <div className="footer-content">
              {/* <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '20px' }}>
                <img src={Amalgam} alt="Amalgam" className="footer-logo" />
                <img src={LinkedIn} alt="Instagram" className='home-footer-linkedin' style={{ alignSelf: "center" }} />
              </div> */}
              <div className="footer-top-row">
                <Link to="/" className="footer-link">Home</Link>
                <span className="footer-separator">•</span>
                <Link to="/ourwork" className="footer-link">Our Work</Link>
                <span className="footer-separator">•</span>
                <Link to="/aboutus" className="footer-link">About Us</Link>
                <span className="footer-separator">•</span>
                <Link to="/case-studies" className="footer-link">Case Studies</Link>
              </div>
              <div className="footer-bottom-row">
                <Link to="/startups" className="footer-link">Launchpad</Link>
                <span className="footer-separator">•</span>
                <Link to="/careers" className="footer-link">Careers</Link>
                <span className="footer-separator">•</span>
                <Link to="/contactus" className="footer-link">Contact</Link>
              </div>
            </div>
          </div>

          <div style={{
            width: "80%",
            height: "0px",
            borderTop: "1px solid black",
            backgroundColor: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingBottom: "20px",
            margin: "0 auto"
          }}>
          </div>
          <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "white",
            gap: isMobile ? "5px" : "20px",
            paddingBottom: "20px",
            width: "100%",
            padding: "0 10px 20px 10px",
            textAlign: "center"
          }}>
            <Link to="/privacy-policy" style={{ textAlign: "center", color: "black", textDecoration: "none" }}>Privacy Policy</Link>
            <span style={{ color: "black", fontSize: "14px" }}>|</span>
            <Link to="/terms-and-conditions" style={{ color: "black", textDecoration: "none" }}>Terms and Conditions</Link>
            <span style={{ color: "black", fontSize: "14px" }}>|</span>
            <Link to="/cookie-policy" style={{ fontSize: "14px", color: "black", textDecoration: "none" }}>Cookie Policy</Link>
          </div>
        </section>
      )}

    </div>
  )
}

export default Careers